import type { JSX, SVGProps } from "react";

/**
 *
 * @param props Any SVG attributes overriding the custom warning icon, such as fill, viewBox, width, height, etc.
 *
 * @default width = 20
 * @default height = 19
 * @default fill = var(--mantine-color-red-6)
 *
 * @returns functional component that returns warning icon SVG
 */
export function Warning(props?: SVGProps<SVGSVGElement>): JSX.Element {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="19"
            fill={"var(--mantine-color-red-6)"}
            viewBox="0 0 20 19"
            {...props}
        >
            <path
                fillRule="evenodd"
                d="M8.466 1.384a3 3 0 0 1 4.143 1.123l7.096 12.242c.023.04.044.083.062.127A3 3 0 0 1 17.007 19H3L2.945 19c-.035.002-.07.002-.107 0a3 3 0 0 1-2.625-4.125.996.996 0 0 1 .062-.125L7.37 2.507a3 3 0 0 1 1.096-1.123ZM2.944 17.002 3 17h13.996a1 1 0 0 0 .937-1.32L10.874 3.502l-.01-.017a1 1 0 0 0-1.75 0l-.01.017-7.058 12.18a1 1 0 0 0 .895 1.32h.003ZM10 7a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1Zm0 6a1 1 0 0 1 1 1v.01a1 1 0 0 1-2 0V14a1 1 0 0 1 1-1Z"
                clipRule="evenodd"
            />
        </svg>
    );
}
